<template>
  <sdz-modal
    ref="sdzModal"
    @close="close"
    :title="modalTitle"
    @saveConfiguration="saveConfiguration"
    @cancelConfiguration="cancelConfiguration"
    confirm-button-label="Adicionar"
    confirmation-event="saveConfiguration"
    cancel-event="cancelConfiguration"
    width="600"
    persistent
    custom-class="default-sheet-modal"
    buttons-position="right"
    close-icon
  >
    <template>
      <div
        class="content"
      >
        <AppLoadingIcon
          v-if="loading"
          class="loading"
          color="#BBB"
        />
        <template v-else>
          <div>
            Ao adicionar os produtos, caso o vendedor atinja o valor mínimo do percentual obtido para todas as faixas, o valor do produto será multiplicado pelo fator correspondente à faixa <b>{{ multiplierName }}</b>.
          </div>
          <AppSelectGroup
            v-model="form"
            :items="campaignHighlightProducts"
            label="Produtos em destaque"
            on-text="productName"
            on-value="productId"
            placeholder="Selecione os produtos"
            clearable
            multiple
          />
        </template>
      </div>
    </template>
  </sdz-modal>
</template>

<script>
  import AppLoadingIcon from '@/components/ui/AppLoadingIcon.vue'
  import AppSelectGroup from '@/components/ui/inputs/AppSelectGroup.vue'

  export default {
    name: 'CampaignTriggerGoalHighlightProductsModal',

    components: {
      AppLoadingIcon,
      AppSelectGroup,
      SdzModal: () => import('@/components/sdz/SdzModal.vue')
    },

    props: {},

    data: () => ({
      loading: false,
      form: [],
      campaignHighlightProducts: [],
      campaign: {},
      goal: {},
      multiplier: {}
    }),

    computed: {
      goalName() {
        return this.goal?.name
      },
      multiplierName() {
        return this.multiplier?.name || `Faixa ${this.multiplier?.range}`
      },
      modalTitle() {
        return `Adicionar produtos - ${this.goalName}`
      }
    },

    methods: {
      open({ campaign, multiplier, campaignHighlightProducts, highlightProducts, goal }) {
        this.loading = true
        this.$refs.sdzModal.show = true
        this.goal = goal
        this.campaign = campaign
        this.multiplier = multiplier
        this.campaignHighlightProducts = campaignHighlightProducts
        this.form = highlightProducts
        this.loading = false
      },
      close() {
        this.$refs.sdzModal.show = false
      },
      cancelConfiguration() {
        this.close()
      },
      async saveConfiguration() {
        try {
          this.loading = true
          this.$emit('updateHighlightProducts', { percentage: this.multiplier.percentage, highlightProducts: this.form })
          this.close()
        } catch (error) {
          this.$toast(error?.response?.data?.message || 'Erro ao salvar configuração', 'red')
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="stylus">
  .default-sheet-modal {
    .content {
      .text-disabled {
        color: rgba(0,0,0,.38);
      }

      .app-checkbox {
        .v-input__slot {
          margin: 0;
        }
        .v-messages {
          min-height: 0;
        }
      }

      padding: 20px 20px 20px 20px;

      .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
      }
      
      .list-header {
        display: flex;
        padding: 0px 16px 12px 16px;
        font-weight: bold;
        color: #555;
      }

      .item-list {
        max-height: 350px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .list-item {
        display: flex;
        align-items: center;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        padding-bottom: 8px;
        padding-top: 8px;

        .col-accelerator {
          padding-left: 12px;
        }
      }

      .col-accelerator { flex: 2.5; }
      .col-items { flex: 4; }
      .col-sdz-prize { flex: 1; text-align: left; }

      .list-item div {
        display: flex;
        align-items: center;
      }

      .header-item-accelerator {
        flex: 2;
      }
      .header-item-items {
        flex: 3
      }
      .header-item-sdz-prize {
        flex: 1;
        text-align: left;
      }


      .cell-accelerator {
        flex: 2;
        display: flex;
        align-items: center;
      }
      .cell-items {
        flex: 3;
        color: #333;
      }
      .cell-sdz-prize {
        flex: 1;
        text-align: left;
        color: #333;
      }
    }
  }
</style>
